/**
 * Configuration de l'API
 * Utilise la variable d'environnement REACT_APP_API_URL si disponible
 * Sinon, utilise l'URL par défaut pour le développement local
 */
const getApiUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;

  // Si l'URL commence par /, c'est une URL relative
  if (envUrl && envUrl.startsWith("/")) {
    return envUrl;
  }

  // Si c'est une URL complète, l'utiliser telle quelle
  if (
    envUrl &&
    (envUrl.startsWith("http://") || envUrl.startsWith("https://"))
  ) {
    return envUrl;
  }

  // Par défaut, utiliser localhost pour le développement
  if (envUrl) return envUrl;
  return process.env.NODE_ENV === "production"
    ? "/api"
    : "http://localhost:3000/api";
};

const API_URL = getApiUrl();

export default {
  baseURL: API_URL,
  timeout: 10000,
};
